import React, { useEffect } from 'react';
import '../styles/cricket99.css';

const Cricbet99Page = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <div className="cricbet99-page">
      <div className="header">
        <h1>
          Welcome to <span className="highlight">Cricbet99</span>: Your Premier Betting Hub
        </h1>
        <img src="/cricbet99logo.webp" alt="Cricbet99 Logo" className="logo" />
      </div>

      <section className="cricbet99-intro">
        <p>
          Experience the next level of sports betting with <span className="highlight">Cricbet99</span>, powered by <span className="highlight">Mahadev</span>. Whether you’re passionate about cricket or looking for a diverse range of betting opportunities, Cricbet99 has everything you need to make every bet count.
        </p>
        <div className="cricbet99-cta-buttons">
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Create Your Demo Account
          </a>
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Get In Touch with Us
          </a>
        </div>
      </section>

      <section className="cricbet99-why-choose">
        <h2>Why Choose <span className="highlight">Cricbet99</span>?</h2>
        <ol>
          <li><strong>Comprehensive Betting Options:</strong> Explore a vast array of sports betting, online casino games, and more—customized by <span className="highlight">Mahadev</span>.</li>
          <li><strong>Dynamic 99 Exchange:</strong> Bet in real time against other users and track your progress with our interactive 99 Exchange platform.</li>
          <li><strong>Guaranteed Transaction Security:</strong> Enjoy secure, seamless payments and withdrawals every time.</li>
          <li><strong>24/7 Support Team:</strong> Need assistance? Our round-the-clock support, led by <span className="highlight">Mahadev</span>, has your back.</li>
        </ol>
        <div className="cricbet99-cta-buttons">
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Create Your Demo Account
          </a>
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Get In Touch with Us
          </a>
        </div>
      </section>

      <section className="cricbet99-features">
        <h2>Features that Make <span className="highlight">Cricbet99</span> Stand Out</h2>
        <ol>
          <li><strong>Exclusive Betting Platform:</strong> Bet big on cricket matches and enjoy thrilling action with every game.</li>
          <li><strong>State-of-the-Art Technology:</strong> Experience a sleek, responsive platform that works flawlessly across devices.</li>
          <li><strong>Innovative 99 Exchange:</strong> Elevate your betting strategy with peer-to-peer betting features only available at Cricbet99.</li>
        </ol>
      </section>

      <section className="cricbet99-getting-started">
        <h2>Getting Started with <span className="highlight">Cricbet99</span></h2>
        <ol>
          <li><strong>Register with Mahadev:</strong> Visit our site, complete a quick signup, and receive your official Cricbet99 ID.</li>
          <li><strong>Explore Betting Options:</strong> Choose from cricket, casino games, and more with real-time updates and stats.</li>
          <li><strong>Place Bets & Enjoy:</strong> Start betting instantly and follow your favorite events live as they unfold.</li>
        </ol>
        <div className="cricbet99-cta-buttons">
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Create Your Demo Account
          </a>
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Get In Touch with Us
          </a>
        </div>
      </section>

      <section className="cricbet99-security">
        <h2>Safety and Security at <span className="highlight">Cricbet99</span></h2>
        <p>
          At Cricbet99, your safety is our priority. All your transactions are encrypted and protected, so you can enjoy a worry-free betting experience.
        </p>
        <p>
          Join <span className="highlight">Cricbet99</span> today for endless excitement, rewarding gameplay, and a trusted platform you can rely on.
        </p>
        <div className="cricbet99-cta-buttons">
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Create Your Demo Account
          </a>
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Get In Touch with Us
          </a>
        </div>
      </section>
    </div>
  );
};

export default Cricbet99Page;
